import React from "react";
import { Box, TextField, Button, ButtonGroup, InputAdornment, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Labels from "../../../labels/Labels";

export default function SearchAndFilters({ searchTerm, onSearchChange, filter, onFilterChange }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        marginBottom: 2,
        padding: 2,
        borderRadius: 1,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {/* Search Input */}
      <TextField
        size="small"
        placeholder={Labels.getLabel("queryBalance.SearchSubBalances", "Search sub-balances...")}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: "250px", backgroundColor: "white" }}
      />

      {/* Filter Buttons */}
      <ButtonGroup size="small">
        <Button
          variant={filter === "all" ? "contained" : "outlined"}
          onClick={() => onFilterChange("all")}
          sx={{
            backgroundColor: filter === "all" ? theme.palette.primary.main : "white",
            color: filter === "all" ? "white" : "#666",
            "&:hover": {
              backgroundColor: filter === "all" ? theme.palette.primary.dark : "#f0f0f0",
            },
          }}
        >
          {Labels.getLabel("queryBalance.All", "All")}
        </Button>
        <Button
          variant={filter === "active" ? "contained" : "outlined"}
          onClick={() => onFilterChange("active")}
          sx={{
            backgroundColor: filter === "active" ? theme.palette.primary.main : "white",
            color: filter === "active" ? "white" : "#666",
            "&:hover": {
              backgroundColor: filter === "active" ? theme.palette.primary.dark : "#f0f0f0",
            },
          }}
        >
          {Labels.getLabel("queryBalance.Active", "Active")}
        </Button>
        <Button
          variant={filter === "inactive" ? "contained" : "outlined"}
          onClick={() => onFilterChange("inactive")}
          sx={{
            backgroundColor: filter === "inactive" ? theme.palette.primary.main : "white",
            color: filter === "inactive" ? "white" : "#666",
            "&:hover": {
              backgroundColor: filter === "inactive" ? theme.palette.primary.dark : "#f0f0f0",
            },
          }}
        >
          {Labels.getLabel("queryBalance.Inactive", "Inactive")}
        </Button>
      </ButtonGroup>
    </Box>
  );
}
